import { render, staticRenderFns } from "./collect.vue?vue&type=template&id=f670703c&scoped=true"
import script from "./collect.vue?vue&type=script&lang=js"
export * from "./collect.vue?vue&type=script&lang=js"
import style0 from "./collect.vue?vue&type=style&index=0&id=f670703c&prod&lang=less&scoped=true"
import style1 from "./collect.vue?vue&type=style&index=1&id=f670703c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f670703c",
  null
  
)

export default component.exports